import {ReactElement, ReactNode} from "react";
import {equals} from "ramda";

export interface PillSelectorProps<T> {
    options: T[]
    selected: T
    onSelect: (t: T) => void
    getLabel: (t: T) => ReactNode
}

export function PillSelector<T>(props: PillSelectorProps<T>): ReactElement {
    return (
        <div className="w-full h-full rounded-full border border-secondary bg-warm-gray
                        flex items-stretch">
            {props.options.map((t, i) => {
                const selected = equals(props.selected, t);
                const label = props.getLabel(t);
                return (
                    <button
                        key={i}
                        onClick={() => props.onSelect(t)}
                        className={`rounded-full flex-auto leading-snug py-1
                                    ${selected ?
                                    'bg-white text-text' :
                                    'bg-none text-gray-1'}`}>
                        {label}
                    </button>
                );
            })}
        </div>
    );
}